// Assumes GSAP + Flip already loaded
gsap.registerPlugin(Flip);

const root = document.querySelector('[data-component="values"]');
const cards = Array.from(root.querySelectorAll('.value-card'));

const DURATION = 0.7;
const EASE = "power2.inOut";

let isAnimating = false;

const ink = getComputedStyle(document.documentElement).getPropertyValue('--ink').trim() || "#27333b";
const bggrey = getComputedStyle(document.documentElement).getPropertyValue('--bg-grey').trim() || "#f7f7f7";
const bluegrey = getComputedStyle(document.documentElement).getPropertyValue('--bluegrey').trim() || "#445664";
const drkBluegrey = getComputedStyle(document.documentElement).getPropertyValue('--drk-bluegrey').trim() || "#27333b";

function textNodes(card) {
    return card.querySelectorAll('.value-title, .value-body');
}

function setAriaExpanded(activeCard) {
    cards.forEach((c) => c.setAttribute('aria-expanded', c === activeCard ? 'true' : 'false'));
}

function applyStaticColors() {
    // Ensure initial colors match initial active state
    const active = root.querySelector('.value-card.is-active') || cards[0];
    if (!active.classList.contains('is-active')) {
        cards.forEach((c, i) => c.classList.toggle('is-active', i === 0));
    }
    setAriaExpanded(active);

    cards.forEach((c) => {
        const isActive = c.classList.contains('is-active');
        gsap.set(c, { backgroundColor: isActive ? bggrey : bluegrey });
        gsap.set(textNodes(c), { color: isActive ? ink : "#fff" });
    });
}

function setActive(next) {
    if (isAnimating) return;

    const current = root.querySelector('.value-card.is-active') || cards[0];
    if (current === next) return;

    isAnimating = true;

    // Capture layout before class change
    const state = Flip.getState(cards);

    // Apply classes for final layout (Flip needs this)
    cards.forEach((c) => c.classList.toggle('is-active', c === next));
    setAriaExpanded(next);

    const tl = gsap.timeline({
        defaults: { duration: DURATION, ease: EASE },
        onComplete: () => { isAnimating = false; }
    });

    // 1) Layout morph
    tl.add(Flip.from(state, { duration: DURATION, ease: EASE, absolute: true, prune: true }), 0);

    // 2) Colors (background + text) in lockstep
    tl.to(current, { backgroundColor: bluegrey }, 0);
    tl.to(next, { backgroundColor: bggrey }, 0);

    tl.to(textNodes(current), { color: "#fff" }, 0);
    tl.to(textNodes(next), { color: ink }, 0);

    // 3) Optional: body readability polish (starts slightly after motion begins)
    const nextBody = next.querySelector('.value-body');
    const currentBody = current.querySelector('.value-body');

    // You can comment these out if you want *strict* “only color + layout”
    tl.to(currentBody, { opacity: 0.85, y: 0, duration: 0.2, ease: "power1.out" }, 0);
    tl.fromTo(
        nextBody,
        { opacity: 0, y: 10 },
        { opacity: 0.9, y: 0, duration: 0.35, ease: "power2.out" },
        0.08
    );
}

// Hover states via JS (won’t fight the main timeline)
// - closed cards: bluegrey -> drkBluegrey
// - active card: stays bggrey
cards.forEach((card) => {
    card.addEventListener('mouseenter', () => {
        if (isAnimating) return;
        if (card.classList.contains('is-active')) return;
        gsap.to(card, { backgroundColor: drkBluegrey, duration: 0.15, ease: "power1.out", overwrite: true });
    });

    card.addEventListener('mouseleave', () => {
        if (isAnimating) return;
        if (card.classList.contains('is-active')) return;
        gsap.to(card, { backgroundColor: bluegrey, duration: 0.15, ease: "power1.out", overwrite: true });
    });

    card.addEventListener('click', () => setActive(card));
});

// Keyboard navigation
root.addEventListener('keydown', (e) => {
    const keys = ["ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown"];
    if (!keys.includes(e.key)) return;

    e.preventDefault();

    const activeIndex = cards.findIndex((c) => c.classList.contains('is-active'));
    const dir = (e.key === "ArrowLeft" || e.key === "ArrowUp") ? -1 : 1;
    const nextIndex = (activeIndex + dir + cards.length) % cards.length;

    cards[nextIndex].focus();
    setActive(cards[nextIndex]);
});

// Init
applyStaticColors();